/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Coffee = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18.7015 4.01097V4C18.7921 4 18.8818 4.00371 18.9704 4.01097H19.1296L19.1296 4.02798C20.782 4.24592 22.0209 5.70871 22.0209 7.42651C22.0209 9.29485 20.5321 10.853 18.7015 10.853C18.5262 10.853 18.3533 10.8393 18.184 10.8126C17.4371 13.3312 16.2885 15.4316 14.8852 16.8582H6.24442C3.93999 14.5154 2.32231 10.3557 2.043 5.51097C2.01456 5.01768 2 4.51728 2 4.01097H18.7015ZM20.5209 7.42651C20.5209 6.47974 19.8884 5.72782 19.0848 5.54344C19.0065 6.87101 18.8278 8.14689 18.562 9.34774C18.608 9.35124 18.6545 9.35301 18.7015 9.35301C19.6563 9.35301 20.5209 8.51455 20.5209 7.42651ZM17.5842 5.511L3.54547 5.51102C3.80414 9.74773 5.14126 13.2784 6.90511 15.3582H14.2245C15.9884 13.2784 17.3255 9.74772 17.5842 5.511Z"
                        fill={color}
                    />
                    <path d="M2 18.57V20.07H19.1296V18.57H2Z" fill={color} />
                </svg>
        );
    };
